import React from 'react';

function rakamlar(props) {
    let ilkdeger = props.data[0];
    let ikincideger = props.data[1];
    let ilkyuzde = ((100 * ilkdeger) / (ilkdeger + ikincideger));
    let ikinciyuzde = ((100 * ikincideger) / (ilkdeger + ikincideger));
    return <>
        <div style={{ width: '100%', textAlign: 'center', fontSize: '12px', float: 'left', fontWeight: 'bold' }}>Toplam:{ilkdeger + ikincideger}</div>
        <div style={{ width: '50%', textAlign: 'center', fontSize: '12px', float: 'left', color: '#32ff7e', fontWeight: 'bold' }}>Olumlu:%{ilkyuzde.toFixed(2)}</div>
        <div style={{ width: '50%', textAlign: 'center', fontSize: '12px', float: 'left', color: '#D91E18', fontWeight: 'bold' }}>Olumsuz:%{ikinciyuzde.toFixed(2)}</div>
        <div style={{ width: '50%', textAlign: 'center', fontSize: '12px', float: 'left', color: '#32ff7e', fontWeight: 'bold' }}>Olumlu:{ilkdeger}</div>
        <div style={{ width: '50%', textAlign: 'center', fontSize: '12px', float: 'left', color: '#D91E18', fontWeight: 'bold' }}>Olumsuz:{ikincideger}</div>
    </>
}

export default rakamlar;